export default __webpack_public_path__ + "static/media/Chaptertitle.44cc34dc.txt";